// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3cwdr","subheader":"ReorderModal_subheader__2vs6b","listWrap":"ReorderModal_listWrap__Q7_gg"};